import React, { useState, useCallback } from 'react';
import "./BakeryAddProductStyles.scss";
import ButtonHint from "../../../../components/Buttons/buttonHint/ButtonHint";
import {MEDIA} from "../../../../utils/js/Const";
import Pluss from "./img/plus.svg"
import Minus from "./img/minus.svg"
import {HandySvg} from "handy-svg";
import {useBakeryAddProduct} from "./lib/useBakeryAddProduct";

const BakeryAddProduct = ({ product, onSuccess, onClose, selectedUserGuid }) => {
    const { addProduct, loading } = useBakeryAddProduct();
    const [count, setCount] = useState(1);

    const getAttachmentId = () => {
        if (product?.goods?.attachment_id) return product.goods.attachment_id;
        if (product?.attachments_guid) return product.attachments_guid;
        return null;
    };

    const getProductName = () => {
        return product?.goods?.name || product?.name || "Название товара";
    };

    const attachmentId = getAttachmentId();
    const imageUrl = attachmentId ? `${MEDIA}/api/attachments/${attachmentId}` : null;
    const productName = getProductName();

    const increment = useCallback(() => {
        setCount(prevCount => Math.min(prevCount + 1, 999));
    }, []);

    const decrement = useCallback(() => {
        setCount(prevCount => Math.max(prevCount - 1, 1));
    }, []);

    const handleInputChange = (e) => {
        let value = parseInt(e.target.value);
        if (isNaN(value)) {
            value = 1;
        }
        value = Math.min(Math.max(value, 1), 999);
        setCount(value);
    };

    const handleAddProduct = async () => {
        if (!count || count <= 0) {
            console.warn('Введите корректное количество');
            return;
        }

        if (!selectedUserGuid) {
            console.warn('Пользователь не выбран');
            return;
        }

        const goodsId = product?.goods?.id || product?.goods_id;

        const taskGuid = product?.guid;

        try {
            await addProduct(
                goodsId,
                count,
                selectedUserGuid,
                taskGuid
            );
            onSuccess?.();
            onClose();
        } catch (error) {
            console.error('Ошибка при добавлении товара:', error);
        }
    };

    return (
        <div className="bakery-add-product">
            <div className="bakery-add-product__header">
                <div className="name">{productName}</div>
                <img
                    src={imageUrl}
                    className="image"
                    alt={productName}
                    onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML += '<div class="image-placeholder">📦</div>';
                    }}
                />
            </div>

            <div className="bakery-add-product__counter">
                <button
                    className="counter-btn counter-btn--minus"
                    onClick={decrement}
                    disabled={count <= 1 || loading}
                >
                    <HandySvg src={Minus} />
                </button>

                <input
                    type="number"
                    className="counter-input"
                    value={count}
                    onChange={handleInputChange}
                    min={1}
                    max={999}
                    disabled={loading}
                />

                <button
                    className="counter-btn counter-btn--plus"
                    onClick={increment}
                    disabled={count >= 999 || loading}
                >
                    <HandySvg src={Pluss} />
                </button>
            </div>

            <ButtonHint
                funck={handleAddProduct}
                text={loading ? "Загрузка..." : "Провести"}
                className="add-btn"
                disabled={loading}
            />
        </div>
    );
};

export default BakeryAddProduct;